<template>
    <div>
        <div class="response-message" v-if="registerInterestComplete">
            <p class="text-success"><i class="fas fa-check-circle"></i> Thanks for registering, we will be in touch soon.</p>
        </div>
        <form class="form" @submit.prevent="onSubmit" v-else>
            <div class="input-group"><input type="email" name="Subscribe[email]"
                                            v-model="email"
                                            class="form-control rounded-circle-left"
                                            placeholder="Enter your email" required>
                <div class="input-group-append">
                    <button class="btn btn-rounded btn-dark" type="submit"><slot name="button">Submit</slot></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: "Subscribe",
    data() {
        return {
            email: '',
            registerInterestComplete: false
        }
    },
    computed: {
        registerInterestUrl() {
            return "/api/v0/subscribers";
        }
    },
    methods: {
        onSubmit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    axios.post(this.registerInterestUrl, {
                        email: this.email
                    }).then(response => {
                        if (response.data.status === "success") {
                            this.registerInterestComplete = true;
                            setTimeout(() => {
                                this.registerInterestComplete = false;
                                this.email = '';
                            }, 2000);
                        } else if (response.data.status === "error") {
                            if (response.data.data.hasOwnProperty('email')) {
                                alert('You have already registered you interest :-)')
                            }
                        }
                    }).catch((error) => {
                        alert('We were unable to register your interest');
                    })
                }
            });
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/Subscribers/Form/Default.vue